module.exports = __webpack_public_path__ + "static/qr-app-store-f3057885577ad17430627d4d5547565a.svg";